@if (pluginInstalled) {
  <my-alert class="mt-3" type="primary" i18n>
    To load your new installed plugins or themes, refresh the page.
  </my-alert>
}

<div class="result-and-search">
  @if (!search) {
    <div>
      <my-global-icon iconName="trending" aria-hidden="true"></my-global-icon>

      @if (isThemeSearch()) {
        <ng-container i18n>Popular themes</ng-container>
      } @else {
        <ng-container i18n>Popular plugins</ng-container>
      }
    </div>
  }

  @if (search && !isSearching) {
    <div>
      <my-global-icon iconName="search"></my-global-icon>

      <ng-container i18n>
        {{ pagination.totalItems }} {pagination.totalItems, plural, =1 {result} other {results}} for "{{ search }}"
      </ng-container>
    </div>
  }

  <div class="search-bar">
    <input type="text" (input)="onSearchChange($event)" i18n-placeholder placeholder="Search..." myAutofocus />
  </div>
</div>

@if (pagination.totalItems === 0) {
  <div class="no-results" i18n>No results.</div>
}

<div class="plugins" myInfiniteScroller (nearOfBottom)="onNearOfBottom()" [dataObservable]="onDataSubject.asObservable()">
  @for (plugin of plugins; track plugin) {
    <my-plugin-card [plugin]="plugin" [version]="plugin.latestVersion" [pluginType]="pluginType">
      <div ngProjectAs="badges">
        @if (plugin.installed) {
          <span i18n class="pt-badge badge-success">Installed</span>
        }

        @if (plugin.official) {
          <span class="pt-badge badge-primary" i18n i18n-title title="This plugin is developed by Framasoft, the not-for-profit that develops PeerTube"
          >Official</span>
        }

        @if (plugin.recommended) {
          <span class="pt-badge badge-primary" i18n i18n-title title="This plugin is recommended by Framasoft, the not-for-profit that develops PeerTube"
          >Recommended</span>
        }
      </div>

      <div ngProjectAs="buttons">
        @if (plugin.installed === true && !isThemeSearch()) {
          <my-edit-button [ptRouterLink]="getShowRouterLink(plugin)" label="Settings" i18n-label [responsiveLabel]="true"></my-edit-button>
        }

        @if (plugin.installed === false) {
          <my-button
            (click)="install(plugin)"
            [loading]="isInstalling(plugin)"
            label="Install"
            [responsiveLabel]="true"
            icon="cloud-download"
            [attr.disabled]="isInstalling(plugin)"
          ></my-button>
        }
      </div>
    </my-plugin-card>
  }
</div>
